import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Homepage from "./pages/Homepage";
import Aktionen from "./pages/Aktionen";
import Spiele from "./pages/Spiele";
import Registrieren from "./pages/Registrieren";
import AppPage from "./pages/AppPage";
import UeberUns from "./pages/UeberUns";

function App() {
  return (
    <div className="App bg-slate-950 min-h-screen">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/aktionen" element={<Aktionen />} />
            <Route path="/spiele" element={<Spiele />} />
            <Route path="/registrieren" element={<Registrieren />} />
            <Route path="/app" element={<AppPage />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
